import React, { useEffect, useState } from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { PageLayout } from 'src/common/PageLayout';
import { Button } from 'src/common/Button';
import { W9Upload } from 'src/app/App/Content/TinReview/W9Upload/W9Upload';
import { PracticeData } from 'src/app/App/Content/TinReview/PracticeData/PracticeData';
import { Locations } from 'src/app/App/Content/TinReview/Locations/Locations';
import { useTinRegistration } from 'src/state/tinRegistration';
import { useSteps } from 'src/state/steps';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { event as adobeTaggingEvent } from '@uhg-abyss/web/tools/event';
import { useUser } from 'src/state/user/hooks';
import { storage } from '@uhg-abyss/web/tools/storage';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { useHistory } from 'react-router-dom';
import { clearForms } from '@src/state/tinRegistration/utils';
import { AttestationData } from './Attestation/AttestationData';
import { TinHeader } from '../TinHeader';
import { StatusBanner } from './StatusBanner';
import { print } from './print';

const Space = styled('div', {
  marginTop: '30px',
});

const PageButtons = styled('div', {
  width: '18%',
  marginTop: '2em',
  paddingBottom: '25px',
  fontWeight: 600,
  fontSize: '16px',
  color: '$core.color.brand.100',
  fontFamily: '$heading',
  display: 'inline-flex',
  marginRight: '15px',
});

export const Confirmation = () => {
  const router = useRouter();
  const form = useForm();
  const { tinSubmission } = useTinRegistration.state();
  const { clearStepTracker } = useSteps();
  const [downloading, setDownloading] = useState(false);
  const npiInfo = form.getValues('practiceInformation.restrictionInput');
  const { setDocumentId } = useTinRegistration.actions();
  const handlePDF = () => {
    const fileName = `TinRegistration_${tinSubmission.trackingNumber}`;
    adobeTaggingEvent('DOWNLOAD_PDF', { fileName });
    const confirmationPage = document.getElementById('print-confirmation');
    setDownloading(true);
    print.savePDF(confirmationPage, npiInfo, fileName, () => {
      setDownloading(false);
    });
  };
  const userInfo = useUser.state();
  const registration = form.getValues('searchRegistration');

  const goToDashboard = () => {
    clearForms(form, clearStepTracker, setDocumentId, storage);
    router.navigate('/');
  };
  useEffect(() => {
    const pageName = 'epvsecure:tin registration: attestation confirmation';
    const billingTin = registration ? registration.billingTin : '';
    const siteSectionLevel = {
      siteSectionLevel1: 'tin registration',
      siteSectionLevel2: 'attestation confirmation',
      siteSectionLevel3: '',
      siteSectionLevel4: '',
      siteSectionLevel5: '',
    };
    adobeTaggingEvent('ON_PAGE_LOAD', {
      userInfo,
      pageName,
      billingTin,
      siteSectionLevel,
    });
  }, []);

  const history = useHistory();
  useEffect(() => {
    return () => {
      if (history && history.action === 'POP') {
        router.navigate('/tin-registration/confirmation');
      }
    };
  });

  return (
    <PageLayout>
      <TinHeader
        callPdf={handlePDF}
        downloading={downloading}
        trackingNumber={tinSubmission.trackingNumber}
      />
      <div id="print-confirmation">
        <Space id="successful-confirmation">
          <StatusBanner
            referenceNumber={tinSubmission.trackingNumber}
            status={!!tinSubmission.trackingNumber}
          />
        </Space>
        <Space id="w9upload-confirmation">
          <W9Upload />
        </Space>
        <Space id="practice-data-confirmation">
          <PracticeData />
        </Space>
        <Space id="locations-confirmation">
          <Locations />
        </Space>
        <Space id="attestation-data-confirmation">
          <AttestationData />
        </Space>
      </div>
      <PageButtons>
        <Button
          type="button"
          id="w9-back-button"
          aria-label="click here to go back"
          data-testid="back-button"
          onClick={goToDashboard}
          width="100%"
          variant="outline"
        >
          Return to dashboard
        </Button>
      </PageButtons>
    </PageLayout>
  );
};
